import React, { Component } from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Business Stratagy',
        description: 'Crafting actionable business strategies that fuel sustainable growth and long-term success.'
    },
    {
        icon: <FiLayers />,
        title: 'Private Label Launch',
        description: 'We build your brand from scratch—finding the perfect product and launching it to market success.'
    },
    {
        icon: <FiUsers />,
        title: 'Marketing & Reporting',
        description: 'Our comprehensive marketing services, backed by daily, weekly, and monthly reports, keep you informed every step of the way.'
    },
    {
        icon: <FiMonitor />,
        title: 'Website Development',
        description: 'We craft engaging e-commerce and portfolio websites that showcase your brand and drive results.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Services',
        description = 'Empowering your business with tailored strategies for growth in both traditional and digital markets, including expert e-commerce solutions on platforms like Amazon and Walmart. Ready to elevate your brand? Let’s create a custom plan just for you.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="/service"><span className="text">Request Custom Service</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href="/service-details">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
